import axios from 'axios';
import * as API from 'app/constants/ApiConstants'
import * as APP from 'app/constants/AppConstants'
import Logoutsession from '../../logout/logoutsession.js'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import refreshTokenApi from '../../refreshtoken/refreshtokenapi';

//upload file
export function uploadjobdetails(Data, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.UPLOADJOBDETAILS_URL, Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}

// upload search
export function uploadSearch(Data, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.JOBSEARCH_URL + Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            )
    })
}
// upload search no reducer
export function uploadSearchNoReducer(Data, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.JOBSEARCH_URL + Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}
//uploadInitiateSearch
export function uploadInitiateSearch(Data, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.INITIATESEARCH_URL + Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}
//jobdescription
export function jobDescription(data, res) {
    let isNonHTML = data.isNonHTML ? data.isNonHTML : "False"
    return new Promise((resolve, reject) => {
        axios.get(API.JOBDESCRIPTION_URL + "?jobid=" + data.jobId + "&isNonHTML=" + isNonHTML,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                // if (APP.SUCCESS == response.status) {
                res(response.data)
                // }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}
//UploadSovren
export function UploadSovren(formData, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.UPLOADSOVRENSELECTED_URL, formData,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS == response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    res(error.response.data)
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}

export function UploadSovrenOtherSrc(formData, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.UPLOADSOVREN_URL, formData,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS == response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}
//attachment edit
export function AttachmentEditApi(data, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.ATTACHMENTEDITURL + "?candId=" + data.candId + "&description=" + data.description,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}

// Run match
export function RunMatch(formData, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.RUNMATCHING_URL + formData,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    resolve(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.status) {
                        refreshTokenApi()
                    }
                    else {
                        reject(error.response.data)
                    }
                }
            );
    });
}

// Run match with weightage
export function RunMatchWithWeightage(data, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.RUNMATCHING_URL, data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token'),
                    'Content-Type': 'application/json'
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    resolve(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.status) {
                        refreshTokenApi()
                    }
                    else {
                        reject(error.response.data)
                    }
                }
            );
    });
}

//GET SAVED RUN MATCHING DETAILS
export function getSavedRunMatchingDetails(formData, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.GET_SAVEDRUN_MATCHING_DETAILS_URL + formData,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    resolve(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.status) {
                        refreshTokenApi()
                    }
                    else {
                        reject(error.response.data)
                    }
                }
            );
    });
}

/* Added the following code for POW-877.Dharma Teja using AI Agent. June 22, 2026. Code Start */
export function getCandidateMatchHistory(jobId, candidateId) {
    return new Promise((resolve, reject) => {
        axios.get(`${API.GET_CANDIDATE_MATCH_HISTORY_URL}?jobId=${jobId}&candidateId=${candidateId}`,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    resolve(response.data)
                }
            },
                (error) => {
                    if (error.response && APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (error.response && APP.TOKENERROR === error.response.status) {
                        refreshTokenApi()
                    }
                    else {
                        reject(error.response ? error.response.data : error)
                    }
                }
            );
    });
}
/* Code end. Dharma Teja using AI Agent. June 22, 2026 */

// Upload work auth
export function uploadjobWorkAuth(res) {
    return new Promise((resolve, reject) => {
        axios.get(API.UPLOADWORKAUTH_URL,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}



//upload job client job whole list
export function uploaddetailsClientJob(res) {
    return new Promise((resolve, reject) => {
        axios.get(API.UPLOADCLIENTJOB_URL,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}

//send resume link 
export function resumeInitiateLink(Data, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.DICERESUMEVIEWLINK_URL + Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {

                if (APP.SUCCESS === response.status) {
                    console.log("response.data", response.data)
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}
//match results
//filter by
export function filterBy(Data, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.FILTERBY_URL + "?jobid=" + Data.jobid + "&sorting=" + Data.sorting + "&sortby=ASC",
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}
//viewresume
export function viewresume(Data, jobid, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.VIEWRESUMES_URL + "?candguid=" + Data + "&jobid=" + jobid,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}
// view resume for candidate search
export function Candidateviewresume(Data, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.VIEWRESUMES_URL + "?candguid=" + Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {

                if (APP.SUCCESS === response.status) {
                    console.log("response.data", response.data)
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}
/* Added the following code for POW-776.Istiyak Khan using AI Agent. March 2, 2026. Code Start */
// send AI caller (Send Call)
export function sendAICaller(Data, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.SEND_AI_CALLER_URL, Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}
/* Code end. Istiyak Khan using AI Agent. March 2, 2026 */
/* Commenting the following code for POW-776.Istiyak Khan using AI Agent. March 2, 2026. Comment Start */
// get call history (Call History modal)
// export function getCallHistory(params, res) {
//     return new Promise((resolve, reject) => {
//         const { candguid = '', jobid = '', candid = '' } = params || {};
//         const query = new URLSearchParams({ candguid, jobid, candid: String(candid) }).toString();
//         axios.post(API.CALL_HISTORY_URL + '?' + query, null, {
//             headers: { 'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token') }
//         })
//             .then(response => {
//                 if (APP.SUCCESS === response.status) {
//                     res(response.data);
//                 }
//             }, (error) => {
//                 if (APP.LOGOUTERROR === error.response.status) {
//                     Logoutsession();
//                     toast("Your session is timed out, not able to proceed further", {
//                         position: toast.POSITION.TOP_CENTER,
//                         className: 'foo-bar'
//                     });
//                 } else if (error.response && error.response.data && APP.TOKENERROR === error.response.data.erroCode) {
//                     refreshTokenApi(error.response.data.refreshToken, (resp) => {
//                         localStorage.setItem('bearer_token', resp.token);
//                         res(resp);
//                     });
//                 } else {
//                     res(error.response && error.response.data ? error.response.data : {});
//                 }
//             });
//     });
// }
/* Commenting end. Istiyak Khan using AI Agent. March 2, 2026 */
//sendBot
export function sendBot(Data, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.SENDBOT_URL, Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}
// send email
export function sendEmailAPI(Data, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.SENDEMAIL_URL, Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}

// send job email
export function sendJobEmailAPI(Data, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.SENDJOBEMAIL_URL, Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}
// Get Job Grabber
export function getJobGrabberAPI(Data, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.GETJOBGRABBER_URL, Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}
//Upload email attachments
export function manageCandidateAttachmentAPI(data, options, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.SENDATTACHMENT_URL, data,
            // {  
            //     headers: {
            //         'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token'),
            //         'Content-Type': 'multipart/form-data',
            //     },
            // }
            options
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}


//Upload Job 
//Manage job email attachments
export function manageJobAPI(data, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.SENDATTACHMENT_URL, data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token'),
                    'Content-Type': 'multipart/form-data',
                },
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}

// send sms
export function sendSMSAPI(Data, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.SENDSMS_URL, Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}

// upload client formatted resume
export function sendFormattedResumeAPI(Data, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.SENDCLIENTFORMATTEDRESUME_URL, Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token'),
                    'content-type': 'multipart/form-data'
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (error.response && APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (error.response && error.response.data && APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response ? error.response.data : { erroCode: 500, erroMessage: 'Network error occurred' })
                    }
                }
            );
    });
}

// Get source type
export function sourcetypeAPI(res) {
    return new Promise((resolve, reject) => {
        axios.get(API.SOURCETYPE_URL,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}

export function ClientResumeFormat(Data, res) {
    return new Promise((resolve, reject) => {
        // Request payload for /api/results/resumeformat (ResumeFormatterRequest: clientName, candid, jobId, resumeId, etc.)
        const requestData = {
            ...Data,
            ...(Data.resumeId && { resumeId: Data.resumeId }),
            ...(Data.jobId != null && Data.jobId !== '' && { jobId: String(Data.jobId) })
        };
        
        axios.post(API.CLIENTRESUMEFORMAT_URL, requestData,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    console.log("response.data", response.data)
                    res(response.data)
                }
            },
                (error) => {
                    if (error.response && APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (error.response && error.response.data && APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response ? error.response.data : { erroCode: 500, erroMessage: 'Network error occurred' })
                    }
                }
            );
    });
}

//For accessing client resume format document created
export function ClientResumeFormatted(Data, res) {
    return new Promise((resolve, reject) => {
        axios.get(Data,
            {
                headers: {
                    // 'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                    // 'Content-Type': 'text/plain',
                    // 'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8',
                    // "Access-Control-Allow-Origin" : "*"                
                    // 'Content-Type': 'application/octet-stream',
                    // 'Content-Type': 'application/json'
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    console.log("response.data", response.data)
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}

export function migrateAPI(Data, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.MIGRATE_URL, Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    console.log("response.data", response.data)
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}


// export function skipSearchAPI(res) {
//     console.log("resAPI",res)
//     return new Promise((resolve, reject) => {
//         axios.get(API.JOBDETAILSKIPSEARCH_URL,
//             {
//                 headers: {
//                     'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
//                 }
//             }
//         )
//             .then(response => {
//                     res(response)
//             },
//             );
//     });
// }

export function skipSearchAPI(Data, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.JOBDETAILSKIPSEARCH_URL + Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                // if (APP.SUCCESS == response.status) {
                // resolve(response.data)
                // }
                // if(response.status==206){
                resolve(response.data)
                // }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}

export function MatchSubmitAPI(Data, res) {
    return new Promise((resolve, reject) => {
        // Always use POST request with new backend structure
        const submitRequest = {
            candid: Data.candid,
            jobid: Data.jobid,
            status: Data.status || "Submitted",
            /* Added the following code for updated API request structure. AI Agent using AI Agent. 2024-12-19. Code Start */
            candidate_name: Data.candidate_name || '',
            email: Data.email || '',
            contact_number: Data.contact_number || '',
            visa: Data.visa || '',
            current_location: Data.current_location || '',
            relocation: Data.relocation || '',
            total_experience: Data.total_experience || '',
            employer_name: Data.employer_name || '',
            /* Code end. AI Agent using AI Agent. 2024-12-19 */
            qna: Data.qna || [],
            /* Added the following code for document attachment functionality. AI Agent using AI Agent. 2024-12-19. Code Start */
            attachments: Data.attachments ? Data.attachments.map(attachment => ({
                fileName: attachment.fileName,
                fileSize: attachment.fileSize,
                fileType: attachment.fileType,
                fileData: attachment.fileData ? attachment.fileData.replace(/^data:[^;]+;base64,/, '') : null
            })) : []
            /* Code end. AI Agent using AI Agent. 2024-12-19 */
        };

        axios.post(API.MATCHSUBMIT_URL, submitRequest, {
            headers: {
                'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token'),
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (APP.SUCCESS === response.status) {
                res(response.data)
            }
        },
            (error) => {
                if (APP.LOGOUTERROR === error.response.status) {
                    Logoutsession()
                    toast("Your session is timed out, not able to proceed further", {
                        position: toast.POSITION.TOP_CENTER,
                        className: 'foo-bar'
                    })
                }
                else if (APP.TOKENERROR === error.response.data.erroCode) {
                    refreshTokenApi(error.response.data.refreshToken, (resp) => {
                        localStorage.setItem('bearer_token', resp.token)
                        res(resp)
                    })
                }
                else {
                    res(error.response.data)
                }
            }
        );
    });
}

// 

export function BacktoCandidateAPI(Data, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.BACKTO_CANDIDATE_URL + '?jobid=' + Data.jobid,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}

export function manageCandidateSkillSetAPI(data, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.MANAGECANDIDATESKILLSET_URL + "?candid=" + data.candid,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}

// Run Job Resume Match
export function RunJobResumeMatch(formData, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.RUN_JOB_RESUME_MATCH_URL, formData,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token'),
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    resolve(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.status) {
                        refreshTokenApi()
                    }
                    else {
                        reject(error.response.data)
                    }
                }
            );
    });
}

/* Added the following code for POW-910.Harsha using AI Agent. September 9, 2026. Code Start */
// Link orphaned resume-job-match results to a newly uploaded candidate
export function linkResumeJobMatchResultAPI(params) {
    return new Promise((resolve, reject) => {
        const query = new URLSearchParams({
            jobId: String(params.jobId || ''),
            runId: String(params.runId || ''),
            candidateId: String(params.candidateId || ''),
            fileKey: String(params.fileKey || ''),
        });

        axios.post(`${API.LINK_RESUME_JOB_MATCH_CANDIDATE_URL}?${query.toString()}`, null, {
            headers: {
                'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token'),
            }
        })
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    resolve(response.data);
                }
            },
            (error) => {
                if (APP.LOGOUTERROR === error.response.status) {
                    Logoutsession();
                    toast("Your session is timed out, not able to proceed further", {
                        position: toast.POSITION.TOP_CENTER,
                        className: 'foo-bar'
                    });
                } else if (APP.TOKENERROR === error.response.status) {
                    refreshTokenApi();
                } else {
                    reject(error.response?.data || error);
                }
            });
    });
}
/* Code end. Harsha using AI Agent. September 9, 2026 */

// Check if job-resume association is valid
export function isJobResumeAssociationValidAPI(clientJobId, res) {
    return new Promise((resolve, reject) => {
        axios.get(API.JOB_RESUME_ASSOCIATION_VALID_URL + "?clientJobId=" + (clientJobId || ""),
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    if (res) {
                        res(response.data);
                    }
                    resolve(response.data);
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response?.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response?.data?.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            if (res) {
                                res(resp)
                            }
                        })
                    }
                    else {
                        if (res) {
                            res(error.response?.data || {})
                        }
                        reject(error.response?.data || error)
                    }
                }
            );
    });
}

export function ViewcontactInfoAPI(Data, res) {
    return new Promise((resolve, reject) => {
        axios.post(API.VIEWCONTACTINFO_URL, Data,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {

                if (APP.SUCCESS === response.status) {
                    console.log("response.data", response.data)
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}

// Update Dice Resume API
export function updateDiceResumeAPI(Data, res) {
    return new Promise((resolve, reject) => {
        // Convert data to URL parameters
        const params = new URLSearchParams();
        params.append('id', Data.id);
        params.append('resumeBase64', Data.resumeBase64);
        params.append('fileName', Data.fileName);
        params.append('extension', Data.extension);

        axios.post(API.DICE_RESUME_UPDATE_URL, params,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token'),
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (error.response && APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (error.response && error.response.data && APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response ? error.response.data : { erroCode: 500, erroMessage: 'Network error occurred' })
                    }
                }
            );
    });
}

//uploaddetailsJobStatus
//upload job whole list
export function uploaddetailsJobStatus(res) {
    return new Promise((resolve, reject) => {
        axios.get(API.UPLOADJOBSTATUS_URL,
            {
                headers: {
                    'Authorization': "Bearer" + " " + localStorage.getItem('bearer_token')
                }
            }
        )
            .then(response => {
                if (APP.SUCCESS === response.status) {
                    res(response.data)
                }
            },
                (error) => {
                    if (APP.LOGOUTERROR === error.response.status) {
                        Logoutsession()
                        toast("Your session is timed out, not able to proceed further", {
                            position: toast.POSITION.TOP_CENTER,
                            className: 'foo-bar'
                        })
                    }
                    else if (APP.TOKENERROR === error.response.data.erroCode) {
                        refreshTokenApi(error.response.data.refreshToken, (resp) => {
                            localStorage.setItem('bearer_token', resp.token)
                            res(resp)
                        })
                    }
                    else {
                        res(error.response.data)
                    }
                }
            );
    });
}
